var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",staticClass:"col",attrs:{"id":"app"}},[(!_vm.isManager && !_vm.isSurveyCakePage)?_c('header-nav'):_vm._e(),_c('div',{staticClass:"body"},[_c('router-view')],1),(!_vm.isManager && !_vm.isSurveyCakePage)?_c('Footer'):_vm._e(),(!_vm.isSurveyCakePage)?_c('copyright'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }